import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';

import { Link, Redirect } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';


class FatigueAuxiliaryReportsAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      generated_result: false,

      first_question_answer: null,
      second_question_first_part_answer: null,
      second_question_second_part_answer: null,
      second_question_third_part_answer: null,
      third_question_answer: null,
      fourth_question_first_option: null,
      fourth_question_second_option: null,
      fourth_question_third_option: null,
      fourth_question_fourth_option: null,
      fourth_question_fifth_option: null,
      fourth_question_sixth_option: null,

      answered_data: {},

      first_question_values: [],
      second_question_first_part_values: [],
      second_question_second_part_values: [],
      third_question_values: [],

      first_question_options: [],
      second_question_first_part_options: [],
      second_question_second_part_options: [],
      third_question_options: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
    
    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/fadiga/ferramenta/auxiliar/info/cadastro';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/');
        if (responseJson.status === 'success') {
          self.setState({
            first_question_options: responseJson.data.first_question_options,
            second_question_first_part_options: responseJson.data.second_question_first_part_options,
            second_question_second_part_options: responseJson.data.second_question_second_part_options,
            third_question_options: responseJson.data.third_question_options,
            first_question_values: responseJson.data.first_question_values,
            second_question_first_part_values: responseJson.data.second_question_first_part_values,
            second_question_second_part_values: responseJson.data.second_question_second_part_values,
            third_question_values: responseJson.data.third_question_values,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
        first_question_answer: this.state.first_question_answer,
        second_question_first_part_answer: this.state.second_question_first_part_answer,
        second_question_second_part_answer: this.state.second_question_second_part_answer,
        second_question_third_part_answer: this.state.second_question_third_part_answer,
        third_question_answer: this.state.third_question_answer,
        fourth_question_first_option: this.state.fourth_question_first_option,
        fourth_question_second_option: this.state.fourth_question_second_option,
        fourth_question_third_option: this.state.fourth_question_third_option,
        fourth_question_fourth_option: this.state.fourth_question_fourth_option,
        fourth_question_fifth_option: this.state.fourth_question_fifth_option,
        fourth_question_sixth_option: this.state.fourth_question_sixth_option,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/reporte/ferramenta/auxiliar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        self.setState({
            generated_result: true,
            answered_data: responseJson.data,
        });
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      {
          !self.state.generated_result ? 
          <div>
            <form onSubmit={this.add}>
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao1QuaoAlertaVoceEsta}</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <Select
                            className="form-field-name"
                            name="first_question_answer"
                            value={this.state.first_question_answer}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'first_question_answer')}
                            options={this.state.first_question_options}
                            required
                        />
                        </div>
                    </div>
                </div>
                <hr />
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao2VoceTeveSonoAdequado}</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.QuantoTempoDormiuNas24HorasAnteriores}</label>
                        <Select
                            className="form-field-name"
                            name="second_question_first_part_answer"
                            value={this.state.second_question_first_part_answer}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'second_question_first_part_answer')}
                            options={this.state.second_question_first_part_options}
                            required
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.QuantoTempoDormiuNas48HorasAnteriores}</label>
                        <Select
                            className="form-field-name"
                            name="second_question_second_part_answer"
                            value={this.state.second_question_second_part_answer}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'second_question_second_part_answer')}
                            options={this.state.second_question_second_part_options}
                            required
                        />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado}</label>
                        <InputMask value={this.state.second_question_third_part_answer} required maskChar={null} name="second_question_third_part_answer" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'second_question_third_part_answer')} placeholder="hh:mm" />
                        </div>
                    </div>
                </div>
                <hr />
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao3QueHorasOcorreAPresenteJornada}</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <Select
                            className="form-field-name"
                            name="third_question_answer"
                            value={this.state.third_question_answer}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'third_question_answer')}
                            options={this.state.third_question_options}
                            required
                        />
                        </div>
                    </div>
                </div>
                <hr />
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao4QualNivelDeRiscoOperacionalAssociado}</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Rota}:</label>
                        <Select
                            className="form-field-name"
                            name="fourth_question_first_option"
                            value={this.state.fourth_question_first_option}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'fourth_question_first_option')}
                            options={[
                                {value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo},
                                {value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado},
                                {value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado},
                            ]}
                            required
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Aeroportos}:</label>
                        <Select
                            className="form-field-name"
                            name="fourth_question_second_option"
                            value={this.state.fourth_question_second_option}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'fourth_question_second_option')}
                            options={[
                                {value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo},
                                {value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado},
                                {value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado},
                            ]}
                            required
                        />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.EspacoAereo}:</label>
                        <Select
                            className="form-field-name"
                            name="fourth_question_third_option"
                            value={this.state.fourth_question_third_option}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'fourth_question_third_option')}
                            options={[
                                {value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo},
                                {value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado},
                                {value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado},
                            ]}
                            required
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.NivelExperienciaTripulacao}:</label>
                        <Select
                            className="form-field-name"
                            name="fourth_question_fourth_option"
                            value={this.state.fourth_question_fourth_option}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'fourth_question_fourth_option')}
                            options={[
                                {value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo},
                                {value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado},
                                {value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado},
                            ]}
                            required
                        />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.CaracteristicasEOperacionalidadeDaAeronave}:</label>
                        <Select
                            className="form-field-name"
                            name="fourth_question_fifth_option"
                            value={this.state.fourth_question_fifth_option}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'fourth_question_fifth_option')}
                            options={[
                                {value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo},
                                {value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado},
                                {value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado},
                            ]}
                            required
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.CondicoesAtmosfericas}:</label>
                        <Select
                            className="form-field-name"
                            name="fourth_question_sixth_option"
                            value={this.state.fourth_question_sixth_option}
                            searchable={true}
                            placeholder={this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao}
                            onChange={this.handleSelectChange.bind(this, 'fourth_question_sixth_option')}
                            options={[
                                {value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo},
                                {value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado},
                                {value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado},
                            ]}
                            required
                        />
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.botaoGerarAvaliacao}</button>
                    </div>
                </div>
            </form>
          </div>
        :
          <div>
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao1QuaoAlertaVoceEsta}</h4>
                <hr />
                <p>
                    {this.state.first_question_values[this.state.first_question_answer]}
                    <br />
                    <span style={{fontStyle: 'italic'}}><strong>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.nota}:</strong> {this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional}</span>
                </p>
                <hr />
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao2VoceTeveSonoAdequado}</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.QuantoTempoDormiuNas24HorasAnteriores}</label><br />
                        {this.state.second_question_first_part_values[this.state.second_question_first_part_answer]}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.QuantoTempoDormiuNas48HorasAnteriores}</label><br />
                        {this.state.second_question_second_part_values[this.state.second_question_second_part_answer]}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado}</label><br />
                        {this.state.second_question_third_part_answer} ({this.state.answered_data.second_question_fourth_part_points} pontos)
                        </div>
                    </div>
                </div>
                <p>
                    <strong>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoPontuacao}:</strong> {this.state.answered_data.second_question_risk_str}
                    <br />
                    <span style={{fontStyle: 'italic'}}><strong>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.nota}:</strong> {this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador}</span>
                </p>
                <hr />
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao3QueHorasOcorreAPresenteJornada}</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        {this.state.third_question_values[this.state.third_question_answer]}
                        </div>
                    </div>
                </div>
                <hr />
                <h4 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao4QualNivelDeRiscoOperacionalAssociado}</h4>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.rota}:</label><br />
                        {this.state.answered_data.fourth_question_first_option_str}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.aeroportos}:</label><br />
                        {this.state.answered_data.fourth_question_second_option_str}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.espacoAereo}:</label><br />
                        {this.state.answered_data.fourth_question_third_option_str}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.nivelExperienciaTripulacao}:</label><br />
                        {this.state.answered_data.fourth_question_fourth_option_str}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.caracteristicasEOperacionalidadeDaAeronave}:</label><br />
                        {this.state.answered_data.fourth_question_fifth_option_str}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                        <label>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.condicoesAtmosfericas}:</label><br />
                        {this.state.answered_data.fourth_question_sixth_option_str}
                        </div>
                    </div>
                </div>
                <p><strong>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoPontuacao}:</strong> {this.state.answered_data.fourth_question_risk_str}</p>
                <hr />
                <h4 className="page-title"><strong>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloResultadoDosRiscos}:</strong> {this.state.answered_data.result_str}</h4>
                <p><strong>{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoOrientacaoAoTripulante}:</strong></p>
                {this.state.answered_data.result == 1 &&
                    <p style={{padding: '20px'}} className="bg-success">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoMecaONivelDeAlertaTripulacaoAumentada}</p>
                }
                {this.state.answered_data.result == 2 &&
                    <p style={{padding: '20px'}} className="bg-warning">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoMecaONivelDeAlertaChochilo}</p>
                }
                {this.state.answered_data.result == 3 &&
                    <p style={{padding: '20px'}} className="bg-danger">{this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoMecaONivelDeAlertaCafeina}</p>
                }
          </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default FatigueAuxiliaryReportsAdd;



// WEBPACK FOOTER //
// ./src/Components/FatigueAuxiliaryReports/FatigueAuxiliaryReportsAdd.js